export const NAV_LINKS = [
  { label: "Inicio",    href: "/", page: "home"    },
  { label: "Catálogo", href: "#vl-7f3a9c", page: "catalog" },
  { label: "Objetivos", href: "/", page: "home", section: "objetivos" },
  { label: "Ubicaciones", href: "#vl-2d8b41", page: "locations" },
  { label: "Sugerencias", href: "#vl-5a6e2d", page: "suggestions" },
  { label: "Equipo",    href: "#vl-9c4b17", page: "team"    },
];

export const HERO_STATS = [
  { value: "24/7", label: "Disponible"  },
  { value: "QR",   label: "Pago rápido" },
  { value: "🌿",   label: "100% sano"   },
];

export const HERO_PILLS = [
  { text: "Personalizado para ti", position: { top: -12, right: -16 }, delay: "0s"   },
  { text: "App conectada",         position: { bottom: 16, left: -28 }, delay: "1.5s" },
];

export const OBJECTIVES = [
  {
    icon:  "accessibility",
    title: "Accesibilidad",
    desc:  "Opciones nutritivas en oficinas, universidades y centros de salud, disponibles 24/7.",
    alt:   false,
    offset: false,
  },
  {
    icon:  "personalization",
    title: "Personalizar",
    desc:  "Recomendaciones únicas basadas en tus necesidades nutricionales a través de la app.",
    alt:   true,
    offset: false,
  },
  {
    icon:  "education",
    title: "Educación",
    desc:  "Tips y contenido para tomar mejores decisiones alimenticias cada día.",
    alt:   false,
    offset: true,
  },
  {
    icon:  "motivation",
    title: "Motivación",
    desc:  "Logros, retos y recompensas para mantenerte comprometido con un estilo de vida sano.",
    alt:   true,
    offset: true,
  },
];

export const VALUES = [
  { num: "01", name: "Bienestar",       icon: "🌱", desc: "Tu salud es nuestra prioridad número uno."              },
  { num: "02", name: "Conexión",        icon: "🔗", desc: "Tecnología que une personas con hábitos saludables."    },
  { num: "03", name: "Modernidad",      icon: "⚡", desc: "Innovación al servicio de la nutrición cotidiana."      },
  { num: "04", name: "Educación",       icon: "💡", desc: "Información clara para decisiones inteligentes."        },
  { num: "05", name: "Personalización", icon: "🎯", desc: "Cada usuario, una experiencia única y adaptada."        },
];

export const CREDO_TAGS = [
  "🌿 Saludable",
  "📱 Digital",
  "🇩🇴 Dominicano",
  "⚡ Inteligente",
  "🎯 Personalizado",
  "📚 Educativo",
];

export const APP_FEATURES = [
  "🥗 Nutrición IA",
  "📊 Seguimiento",
  "🛒 Compra rápida",
  "🔔 Notificaciones",
];

export const TEAM = [
  { initials: "MS", name: "Melanie Salazar",  id: "23-0169", role: "Co-Fundadora", photo: require("../assets/melanie.png") },
  { initials: "HR", name: "Hansell Rodriguez", id: "23-0094", role: "Co-Fundador",  photo: require("../assets/hansell.png") },
];

export const COMPANY_CONTACT = {
  whatsappNumber: "18493545215",
  whatsappDisplay: "+1 (849) 354-5215",
  whatsappMessage: "¡Hola VittaLink! Me gustaría recibir más información sobre sus máquinas expendedoras saludables.",
};
